import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import update from 'immutability-helper';

import PropTypes from 'prop-types';
import { navigate, hideDialog } from '../../actions';
import { getPresupuestoDetalle, updatePresupuestoDetalle, getNewPresupuestoDetalle } from '../../actions/presupuesto_actions';

import { withStyles } from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';

//components:
import NeuriteGrid from '../../components/neurite_grid';
//import FloatNumberFormatInput from '../../components/float_number_input_formatter';
import FloatPercentFormatInput from '../../components/float_percent_input_formatter';

import * as config from '../../constants/configuration';
import { Button } from '@material-ui/core';

const styles = theme => ({
    root: {
        flexGrow: 1,
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
    },
    centroSelect: {
        maxWidth: 240
    },
    toolbar: {
        display: 'block',
        minHeight: '112px'
    },
    spinnerContainer: {
        width: '95%',
        height: 220,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    spinner: {
        width: '50px !important',
        height: '50px !important',
    },
    input: {
        width: 80,
        margin: theme.spacing(1),
    },
    inputImporte: {
        textAlign: 'right',
        margin: 8,
        padding: 0,
        fontSize: 12,
    },
    button: {
        margin: '15px 8px',
        padding: '10px 4%',
        borderRadius: 0,
        textTransform: 'capitalize',
        color: 'white',
        border: 'none',
        boxShadow: 'none',
    },
    buttonGenera: {
        margin: theme.spacing(1),
        padding: '10px 20px',
        borderRadius: 0,
        textTransform: 'capitalize',
        color: 'white',
        border: 'none',
        boxShadow: 'none',
    },
    totales: {
        display: 'flex',
        alignItems: 'center'
    },
    divOptions: {
        display: 'flex',
    }
});

const months = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];

class PresupuestoDetalle extends Component {

    constructor(props) {
        super(props);

        this.state = {
            //mes: parseInt(this.props.match.params.id),
            mes: this.props.mes,
            year: this.props.presupuesto.presupuesto.year,
            centro_id: this.props.presupuesto.presupuesto.centroId,
            zona_id: '',
            iTipoZona: '',
            //yearRef: this.props.presupuesto.presupuesto.refYearsReal[0].year,
            yearRef: this.props.presupuesto.presupuesto.year - 1,
            rows: [],
            coef: 0.0,
            realOrPpto: 'real',
            updating: false
        };
    };

    componentDidMount() {

        if (!this.props.user && config.AUTH) {
            this.props.navigate(""); //go to home page
            return;
        }

    }

    componentDidUpdate(prevProps, prevState) {

        if (prevProps.presupuestoDetalle.presupuesto !== this.props.presupuestoDetalle.presupuesto) {
            if (this.props.presupuestoDetalle.reload) {
                this.props.getPresupuestoDetalle(this.state.centro_id, this.state.year, this.state.yearRef, this.state.mes + 1, this.state.zona_id, this.state.iTipoZona === 5, this.state.realOrPpto === 'real', this.props.presupuesto_id);
            }
            else {
                let rows = [];
                if (this.props.presupuestoDetalle.presupuesto.values) {

                    this.props.presupuestoDetalle.presupuesto.values.forEach((v, index) => {

                        let refValue = this.props.presupuestoDetalle.presupuesto.refValues.find(vr => vr.fecha.slice(4,10) === v.fecha.slice(4, 10));
                        if(!refValue) refValue = 0.0;

                        const date1 = new Date(v.fecha.slice(0, 10));
                        //const date2 = new Date(refValue.fecha.slice(0, 10));
                        const date2 = new Date(this.state.yearRef, date1.getMonth(), date1.getDate());

                        rows.push({
                            dia: date1.getDate() + ' de ' + months[date1.getMonth()],
                            fecha: date1,
                            refValue: refValue ? refValue.valor : 0.0,
                            value: v.valor,
                            isGray1: date1.getDay() === 0 || date1.getDay() === 6,
                            isGray2: date2.getDay() === 0 || date2.getDay() === 6,
                            isGray3: date1.getDay() === 0 || date1.getDay() === 6
                        })
                    });
                }
                this.setState({ ...this.state, rows: rows, updating: false });
            }
        }

    }

    handleSelectZonasValueChange = event => {

        const iTipoZona = this.props.presupuesto.presupuesto.zonas.find(z => z.id === event.target.value).iTipoZona;
        this.setState({ ...this.state, zona_id: event.target.value, iTipoZona: iTipoZona });
        this.props.getPresupuestoDetalle(this.state.centro_id, this.state.year, this.state.yearRef, this.state.mes + 1, event.target.value, iTipoZona === 5, this.state.realOrPpto === 'real', this.props.presupuesto_id);

    }

    handleYearOrigenValueChange = (event) => {
        this.setState({ ...this.state, yearRef: parseInt(event.target.value) });
        this.props.getPresupuestoDetalle(this.state.centro_id, this.state.year, parseInt(event.target.value), this.state.mes + 1, this.state.zona_id, this.state.iTipoZona === 5, this.state.realOrPpto === 'real', this.props.presupuesto_id);
    }

    renderSelectOrigenYears = () => {
        // if (this.props.presupuesto.presupuesto.refYearsReal) {
        //     return this.props.presupuesto.presupuesto.refYearsPpto.map(y => {
        //         return (<option key={'year_' + y.year} value={y.year}>{y.year}</option>);
        //     })
        // }

        const anyos = [];

        if (this.props.presupuesto.presupuesto.refYearsPpto || this.props.presupuesto.presupuesto.refYearsReal) {
           
            this.props.presupuesto.presupuesto.refYearsPpto.forEach(y => {
                anyos.push(y.year);
            });

            this.props.presupuesto.presupuesto.refYearsReal.forEach(y => {
                if (!anyos.includes(y.year)) anyos.push(y.year);
            });

            anyos.sort(function (a, b) { return a - b });

            return anyos.map(y => {
                return (<option key={'year_' + y} value={y}>{y}</option>);
            })

        }

    }

    coefChange = event => {
        this.setState({ ...this.state, coef: event.target.value });
    }

    handleGridRowsUpdated = ({ fromRow, toRow, updated }) => {

        var rows = this.state.rows.slice();

        for (let i = fromRow; i <= toRow; i++) {
            let updatedRow = update(this.state.rows[i], { $merge: updated });
            rows[i] = updatedRow;
        }

        this.setState({ ...this.state, rows: rows });

    };

    renderGrid = () => {


        const { classes } = this.props;

        if (this.props.presupuestoDetalle.isLoading) {
            return (
                <div className={classes.spinnerContainer}>
                    <CircularProgress className={classes.spinner} color="primary" />
                </div>
            )
        }

        let columns = [
            { key: 'dia', name: 'Fecha', editable: false, draggable: false, width: 120, grayField: 'isGray1' },
            { key: 'refValue', name: 'Año ref.', editable: false, draggable: false, width: 120, type: 'float', grayField: 'isGray2' },
            { key: 'value', name: 'Año actual', editable: !this.props.cerrado, draggable: false, width: 120, type: 'float', grayField: 'isGray3' }
        ];

        return (
            <NeuriteGrid
            id="p_d"
                columns={columns}
                rows={this.state.rows}
                buttonEdit={false}
                buttonDelete={false}
                buttonNew={false}
                onRowsUpdated={this.handleGridRowsUpdated}
                height={500}
                width={380}
            />
        )

    }

    updatePresupuesto = () => {
        //const zona = this.props.presupuesto.presupuesto.zonas.find(z => z.iTipoZona === this.state.iTipoZona);

        this.props.updatePresupuestoDetalle(
            this.state.zona_id,
            this.state.rows.map(r => {
                return {
                    fecha: r.fecha,
                    valor: r.value
                }
            }),
            this.props.presupuesto_id
        );
        this.setState({ ...this.state, updating: true });

    }


    handleRealChange = (event) => {
        this.setState({ ...this.state, realOrPpto: event.target.value });
        this.props.getPresupuestoDetalle(this.state.centro_id, this.state.year, this.state.yearRef, this.state.mes + 1, this.state.zona_id, this.state.iTipoZona === 5, event.target.value === 'real', this.props.presupuesto_id);
    }

    renderSpinner = () => {
        const { classes } = this.props;
        return (
            <div className={classes.spinnerContainer}>
                <CircularProgress className={classes.spinner} color="primary" />
            </div>
        )
    }

    render() {

        const { classes } = this.props;

        if (this.state.updating) return this.renderSpinner();

        else {
            return (

                <div className={classes.root}>

                    {/* <div className={classes.toolbar} /> */}
                    <div>
                        <FormControl className={classes.formControl}>
                            <InputLabel>Zona</InputLabel>
                            <Select className={classes.centroSelect}
                                value={this.state.zona_id}
                                onChange={(event) => this.handleSelectZonasValueChange(event)}
                                name="zonaId" >
                                {this.props.presupuesto.presupuesto.zonas.map(z => {
                                    return (<MenuItem key={'zona_' + z.id} value={z.id}>{z.descr}</MenuItem>)
                                })}
                            </Select>
                        </FormControl>
                        <FormControl className={classes.formControl}>
                            <InputLabel>Año ref</InputLabel>
                            <Select
                                native
                                value={this.state.yearRef}
                                onChange={(event) => this.handleYearOrigenValueChange(event)}
                                name={'year'}
                                disabled={this.state.zona_id === ''}
                            >
                                {this.renderSelectOrigenYears()}
                            </Select>
                        </FormControl>

                        <FormControl component="fieldset" className={classes.formControl} variant='outlined'>
                            <RadioGroup row
                                aria-label="Option 1"
                                name="opt1"
                                className={classes.group}
                                value={this.state.realOrPpto}
                                onChange={(event) => this.handleRealChange(event)}
                                disabled={this.state.zona_id === ''}
                            >
                                <FormControlLabel value={'ppto'} control={<Radio />} label={'Presupuesto'} disabled={this.state.zona_id === ''}/>
                                <FormControlLabel value={'real'} control={<Radio />} label={'Real'} disabled={this.state.zona_id === ''}/>
                            </RadioGroup>
                        </FormControl>
                    </div>


                    {this.renderGrid()}

                    <div className={classes.totales}>
                        <Typography variant="subtitle2" style={{ margin: '10px 8px' }}>{'Incremento'}</Typography>
                        <TextField
                            id="coef"
                            value={this.state.coef}
                            onChange={this.coefChange}
                            className={classes.input}
                            InputProps={{ classes: { input: classes.inputImporte }, inputComponent: FloatPercentFormatInput }}
                            variant="outlined"
                        />

                        <Button variant="contained" color="primary" className={classes.buttonGenera} disabled={this.props.cerrado} onClick={() => {
                            this.props.getNewPresupuestoDetalle(
                                this.state.centro_id,
                                this.state.year,
                                this.state.yearRef,
                                this.state.mes + 1, //months in c# start with 1
                                this.state.iTipoZona,
                                this.state.coef,
                                this.state.realOrPpto === 'real'
                            );
                        }}>{'Generar Presupuesto'}</Button>
                    </div>

                    <div className={classes.bottomBtn}>
                        <Button hidden={this.props.isDiaCerrado} variant="contained" color="secondary" className={classes.button} onClick={() => this.props.hideDialog()}>Cerrar</Button>
                        <Button variant="contained" color="primary" hidden={this.props.cerrado} className={classes.button} onClick={() => { this.updatePresupuesto() }}>Guardar</Button>
                    </div>

                </div>
            )
        }
    }

}

PresupuestoDetalle.propTypes = {
    //paraneters
    mes: PropTypes.number.isRequired,
    presupuesto_id: PropTypes.number.isRequired,
    cerrado: PropTypes.bool.isRequired,
    //state
    user: PropTypes.object.isRequired,
    //dispatch
    navigate: PropTypes.func.isRequired,

};

function mapStateToProps(state) {
    return {
        user: state.oidc.user,
        presupuesto: state.presupuesto,
        presupuestoDetalle: state.presupuestoDetalle
    };
};

function mapDispathToProps(dispatch) {
    return bindActionCreators({
        navigate,
        getPresupuestoDetalle,
        updatePresupuestoDetalle,
        getNewPresupuestoDetalle,
        hideDialog
    }, dispatch);
};

export default connect(
    mapStateToProps,
    mapDispathToProps
)(withStyles(styles, { withTheme: true })(PresupuestoDetalle));